
import { defineComponent, PropType } from 'vue';
import ListElement from '@/components/atoms/ListElement.vue';
import { TimeOutContent } from '@/domain/services/types';
import Button from '../atoms/button.vue';

export default defineComponent({
  components: { ListElement, Button },
  emits: ['desactivateStep3'],
  props: {
    content: {
      type: Object as PropType<TimeOutContent>,
      required: true,
    },
  },
});
